import { render, staticRenderFns } from "./PencilButton.vue?vue&type=template&id=edbe1bfa&scoped=true&"
import script from "./PencilButton.vue?vue&type=script&lang=ts&"
export * from "./PencilButton.vue?vue&type=script&lang=ts&"
import style0 from "./PencilButton.vue?vue&type=style&index=0&id=edbe1bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbe1bfa",
  null
  
)

export default component.exports